import React, {Component} from 'react'
import {Box} from "@material-ui/core/index";
import moment from "moment";
import 'moment/locale/es';
import {ReactGrid} from 'components/helpers/reactGrid/reactGrid';
import {RemitosService} from "services";
import {withSnackbar} from "notistack";
import {sortDate, sortNumeric} from "assets/utils";
import {MainContext} from "contexts/main.context";
import SubHeader from "components/helpers/subHeader/subHeader";
import {DateRangeControl} from "components/helpers/dateRange/dateRange.control";

export class RemitosList extends Component {
    state = {
        desde: moment().subtract(30, 'days'),
        hasta: moment(),
        columns: [
            {name: 'id', title: 'ID'},
            {name: 'remito', title: 'N° Documento'},
            {name: 'factura', title: 'N° Factura'},
            {name: 'ingreso', title: 'Ingreso'},
            {name: 'importe', title: 'Importe'},
            {name: 'cliente', title: 'Cliente'}
        ],
        columnExtensions: [
            {columnName: 'id', compare: sortNumeric, direction: 'desc', width: 100},
            {columnName: 'remito', width: 135},
            {columnName: 'factura', width: 135},
            {columnName: 'ingreso', compare: sortDate, direction: 'desc', width: 100},
            {columnName: 'importe', type: 'currency', compare: sortNumeric, width: 150}
        ],
        rows: []
    };

    RemitosService = new RemitosService(this.context);

    componentDidMount() {
        this.loadRemitos();
    }

    loadRemitos = () => {
        const {desde, hasta} = this.state;
        this.RemitosService.getAll(
            desde.format('DD/MM/Y'),
            hasta.format('DD/MM/Y'),
            response => this.setState({rows: response.data.result}),
            error => this.props.enqueueSnackbar(error, {variant: 'error'}));
    }

    navView = (row) => {
        this.props.history.push(`${this.props.match.url}/view/${row.id}`);
    };

    changeRango = (desde, hasta) => {
        this.setState({desde, hasta}, this.loadRemitos);
    }

    render() {
        const {columns, columnExtensions, rows, desde, hasta} = this.state;
        return (
            <Box className='niquel-remitos-list'>
                <SubHeader
                    title={'Remitos'}
                    subtitle={'Remitos de Venta'}
                />
                <Box className='container-xl mt-3 mb-3'>
                    <ReactGrid
                        title={`Remitos del sistema (${rows.length})`}
                        height={-200}
                        columns={columns}
                        columnExtensions={columnExtensions}
                        rows={rows}
                        showFilters={false}
                        rowClick={true}
                        onRowClick={this.navView}
                        customBtn1={
                            <DateRangeControl
                                className={'ml-2'}
                                desde={desde}
                                hasta={hasta}
                                onChange={this.changeRango}
                            />
                        }
                    />
                </Box>
            </Box>
        )
    }
}

RemitosList.contextType = MainContext;
RemitosList = withSnackbar(RemitosList);